import { render, staticRenderFns } from "./MpMillionaires.vue?vue&type=template&id=e03bdf6a&scoped=true&"
import script from "./MpMillionaires.vue?vue&type=script&lang=js&"
export * from "./MpMillionaires.vue?vue&type=script&lang=js&"
import style1 from "./MpMillionaires.vue?vue&type=style&index=1&id=e03bdf6a&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e03bdf6a",
  null
  
)

export default component.exports